import {useContext, useState, useEffect} from 'react'
import axios from 'axios'
import { ContactWrapper, Wrapper } from './style'
import Input from "../../Input"
import { CountryDropdown, StateDropdown } from '../../DropDowns'
import Dropdown from "../../Dropdown"
import { bulkOrderApi } from '../../../api'
import {AuthContext} from "../../../context/auth.js"
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
const Index = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { isLoading, setIsLoading, setNotification, setBulkOrderModal } = useContext(AuthContext)
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [company, setCompany] = useState('');
    const [country, setCountry] = useState('United States');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [description, setDescription] = useState('');
    const [cities, setCities] = useState([]);
    const [products, setProducts] = useState([])

    const sendContact = async () => {
        setIsLoading(true);

        if (!executeRecaptcha) {
            setNotification({ type: 'red', message: 'reCAPTCHA not ready. Please refresh.' });
            setIsLoading(false);
            return;
        }

        const token = await executeRecaptcha('bulk_order_form').catch(() => null);

        if (!token) {
            setNotification({ type: 'red', message: 'reCAPTCHA failed. Please try again.' });
            setIsLoading(false);
            return;
        }

        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!email || !isValidEmail) {
            setNotification({ type: 'red', message: 'Please enter a valid Email Address' });
            setIsLoading(false);
            return;
        }

        const data = {
            first_name: firstName,
            last_name: lastName,
            email,
            company,
            country,
            state,
            city,
            message: description,
            email_to: 'admin@ozandac.com',
            products,
            token
        }
        try {
            const response = await bulkOrderApi(data)
            if (response?.status === 200) {
                setFirstName('')
                setLastName('')
                setEmail('')
                setCompany('')
                setProducts([])
                setDescription('')
                setIsLoading(false)
                setNotification({
                    type: 'success',
                    message: 'Message sent successfully!'
                })
            } else {
                throw new Error();
            }
        } catch {
            setNotification({ type: 'red', message: 'Something went wrong. Please try again.' });
        } finally {
            setIsLoading(false);
        }
    }

  useEffect(() => {
    if (state === undefined) return
    if (state) {
      setIsLoading(true)
      axios.post('https://countriesnow.space/api/v0.1/countries/state/cities', {
        country: country,
        state: state
      }).then((res) => {
        setCities(res.data.data)
        setCity(res.data.data[0])
      }).catch((err) => {
        const errMsg = err?.response?.data?.msg
        if (errMsg === 'state not found') {
          setCities([state])
          setCity(state)
        } else {
          setCities([])
          setCity()
        }
      }).finally(() => {
        setIsLoading(false)
      })
    }
  }, [state])


  return (
    <Wrapper>
        <div className="bulk-order-modal-content">
          <i className='fal fa-times close' onClick={() => {
            setBulkOrderModal(false)
          }}></i>  
            <ContactWrapper>
                <div className="left-container">
                    <div className="solutions-text">
                        <h2 style={{ width: '100%' }}>Bulk <span>Orders</span></h2>
                        <p>Please contact Identifyn® using this form. </p>
                        <p>Select topic from dropdown and briefly describe how we can help.
                        </p>
                    </div>
                </div>
                <div className="right-container">
                    <div className="form-container">
                        <div className="form-wrapper">
                            <div
                                style={{ display: "block", width: "100%", marginTop: "20px", marginBottom: '20px' }}
                            >
                                <div className="two-column">
                                    <Input placeholder="Your First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    <Input placeholder="Your Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                </div>
                                <Input placeholder="Your Email" type='email' style={{ marginBottom: '20px' }} value={email} onChange={(e) => setEmail(e.target.value)} />
                                <Input placeholder="Your Company/Institution" style={{ marginBottom: '20px' }} value={company} onChange={(e) => setCompany(e.target.value)} />
                                <div className="three-column">
                                    <CountryDropdown value={country} onChange={(value) => {
                                        setCountry(value)
                                        setState('')
                                        setCities([])
                                        setCity('')
                                    }} />
                                    <StateDropdown value={state} country={country} placeholder={"State"} onChange={(value) => {
                                        setState(value)
                                        setCities([])
                                        setCity('')
                                    }} />
                                    <select
                                        data-kt-select2='true'
                                        data-placeholder='City'
                                        data-allow-clear='true'
                                        data-kt-user-table-filter='two-step'
                                        data-hide-search='true'
                                        value={city}
                                        onChange={(e) => {
                                            setCity(e.target.value)
                                        }}
                                        placeholder='City'
                                    >
                                        <option disabled selected>City </option>
                                        {cities && cities.length && cities?.map((city) => {
                                            return <option key={city} value={city}>{city}</option>
                                        })}
                                    </select>
                                </div>
                                <Dropdown
                                    value={products}
                                    onChange={(e) => {
                                        setProducts((prev) => {
                                            const newProducts = [...prev];
                                            const index = newProducts.indexOf(e);
                                            if (index > -1) {
                                                newProducts.splice(index, 1);
                                            } else {
                                                newProducts.push(e);
                                            }
                                            return newProducts;
                                        })
                                    }}
                                    style={{ marginBottom: '20px', width: '100%' }}
                                    label={'Select Products - Primary, Direct Conjugate, Secondary Antibodies, Image Services'}
                                    optionType='array'
                                    checkboxes={true}
                                    options={
                                        [
                                            "Primary Antibodies",
                                            "Direct Conjugates",
                                            "Secondary Antibodies",
                                            "Image Services"
                                        ]
                                    }
                                />
                                <textarea
                                    style={{ resize: "none", borderRadius: "8px" }}
                                    placeholder='Describe your intended product use.'
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                ></textarea>
                            </div>
                            <button class="btn" style={{ float: 'right' }}
                                disabled={!firstName || !lastName || !email || !country || !state || !city || !description || !company || isLoading || !products.length}
                                onClick={sendContact}
                            >Get In Touch!</button>
                        </div>
                    </div>
                </div>
            </ContactWrapper>
        </div>
    </Wrapper>
  )
}

export default Index